import { useContext, useMemo } from "react";
import { LoansContext } from "providers/loans";
import { Revenue } from "../types/analytics-data";
import { useXeroAccounts } from "hooks/xero-accounts/use-xero-accounts";

export function useRevenue() {
	const { loans, loadingLoans } = useContext(LoansContext);

	const { data: accounts, isLoading: loadingAccounts } = useXeroAccounts();

	const data = useMemo(() => {
		return new Revenue(loans ?? [], accounts ?? []);
	}, [loans, accounts]);

	function isLoading() {
		return loadingLoans || loadingAccounts;
	}

	return {
		data,
		isLoading,
	};
}
